export default "__VITE_ASSET__B5n5XQGN__"